import React from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { ActionCard } from './ActionCard';
import canUserAccess from '../../../utils/canUserAcces';

const CardList = ({ user }) => {
  const theme = useTheme();

  return (
    <>

      {canUserAccess(user, '/patients')
    && (
    <Grid key='Data' item xs={12} md={4} lg={4}>
      <ActionCard header='Data' content='Enter / Edit Patient Data' type='edit' link='/patients'>
        <AccountCircleIcon htmlColor={theme.palette.green.main} />
      </ActionCard>
    </Grid>
    )}

      {canUserAccess(user, '/studies')
    && (
    <Grid key='Study' item xs={12} md={4} lg={4}>
      <ActionCard header='Study' content='Enter / Edit Study' type='announcement' link='/studies'>
        <AccountCircleIcon htmlColor={theme.palette.green.main} />
      </ActionCard>
    </Grid>
    )}

      {canUserAccess(user, '/sites')
    && (
    <Grid key='Site' item xs={12} md={4} lg={4}>
      <ActionCard header='Site' content='Enter / Edit Site' type='announcement' link='/sites'>
        <AccountCircleIcon htmlColor={theme.palette.green.main} />
      </ActionCard>
    </Grid>
    )}

      {canUserAccess(user, '/dashboards')
    && (
    <Grid key='Reporting' item xs={12} md={4} lg={4}>
      <ActionCard header='Reporting' content='View Dashboards' type='edit' link='/dashboards'>
        <AssessmentIcon htmlColor={theme.palette.primary.main} />
      </ActionCard>
    </Grid>
    )}

      {canUserAccess(user, '/users')
    && (
    <Grid key='Users' item xs={12} md={4} lg={4}>
      <ActionCard header='Users' content='Enter / Edit User' type='announcement' link='/users'>
        <AccountCircleIcon htmlColor={theme.palette.green.main} />
      </ActionCard>
    </Grid>
    )}

      {canUserAccess(user, '/import')
    && (
    <Grid key='Upload CSV' item xs={12} md={4} lg={4}>
      <ActionCard header='Upload CSV' content='Import Data' type='import' link='/import'>
        <AccountCircleIcon htmlColor='#AA8BFF' />
      </ActionCard>
    </Grid>
    )}
    </>
  );
};

export default CardList;
